import React from "react";
import type { TableCellType } from "../Table";

export const tableCellTypesEnum = {
  TEXT: "text",
  COMPONENT: "component",
} as const;

export interface TableCellProps {
  children?: React.ReactNode;
  type?: TableCellType;
  multiLine?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  "data-testid"?: string;
}

const TableCell: React.FC<TableCellProps> = ({
  children = undefined,
  type = tableCellTypesEnum.TEXT,
  multiLine = false,
  className = "",
  onClick = () => {},
  "data-testid": dataTestId,
}) => {
  return (
    <div
      onClick={(e) => {
        onClick(e);
      }}
      className={`td-content ${type === "text" ? "is-text" : "is-component"} ${
        className ? className : ""
      } ${multiLine ? "is-multiline" : ""}`}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default TableCell;
